/**
 * @license UNLICENSED  - Copyright Shutterfly, Inc. 2017 - all rights reserved
 */
import * as _ from "underscore";

import { EventHandler } from "../../lib/EventHandler";
import { $sflyBridge } from "../../lib/Global";
import { DtlManager } from "./dtl";

// window.s = window.s || {};

export class AdobeAnalyticsBase {
    public handle: string = "AdobeAnalytics";
    public evt: EventHandler;
    public dtl: DtlManager = new DtlManager();

    constructor() {
        this.evt = new EventHandler(this);
        this.removeData = this.removeData.bind(this);
        this.putData = this.putData.bind(this);
    }

    // adds a list of generic listener functions
    public genericHooks(): void {
        this.evt.on("fireTrack", this.fireTrack);
        this.evt.on("fireTrackLink", this.fireTrackLink);
        this.evt.on("fireDirectCall", this.fireDirectCall);
        this.evt.on("putData", this.putData);
        this.evt.on("removeData", this.removeData);
    }

    // fire an Adobe track event
    public fireTrack(): void {
        // old analytics
        window.s.t();
    }

    // fire an Adobe track link event
    public fireTrackLink(): void {
        // old analytics
        window.s.tl();
    }

    // fires an Adobe direct call
    public fireDirectCall(dcName: string): void {
        window._satellite.track(dcName);
    }

    /*
    putData fills the DTL with data specified in object parameter
    If object contains a parameter "context" than the merge will use setting the context object
    Else it will use root object as it"s context.
    */
    public putData(this: any, data: any) {
        let context: string = "";
        let noClobber: boolean = false;

        // Do not merge together new event data with old event data
        if (typeof(data.event) !== "undefined") {
            this.dtl.clearDTLVars(["event"]);
        }

        if (!!data.context) {
            context = data.context;
            data = _.omit(data, "context");
        }

        if (!!data.noClobber) {
            noClobber = data.noClobber;
            data = _.omit(data, "noClobber");
        }

        this.dtl.putDtlVar(context, data, noClobber);
    }

    public removeData(this: any, contextPath: string): void {
        this.dtl.clearDTLVars([contextPath]);
    }

}

export const adobe = new AdobeAnalyticsBase();
adobe.genericHooks();

$sflyBridge.addPlugin("adobe", adobe);
$sflyBridge.dispatch("sfly-bridge:plugin:adobe:loaded", {});
